import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueKonva from 'vue-konva'
import axios from 'axios'

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

Vue.use(VueKonva);

//ホットリロード時コンソールの初期化
if (module.hot) {
  module.hot.accept()
  module.hot.addStatusHandler(status => {
    if (status === 'prepare') console.clear()
  })
}

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
